import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ViewsResponse } from './ViewType.types.tsx';

export const SUMMARY_PAGE_VIEWS_RESOURCE_KEY = 'SERVICE_DESK_PROJECT_SUMMARY_VIEWS';

export const summaryPageViewsResource: RouteResource<ViewsResponse> = createResource<ViewsResponse>(
	{
		type: SUMMARY_PAGE_VIEWS_RESOURCE_KEY,
		getKey: ({ match, query }) => {
			const { projectKey } = getProjectKeyId(match, query);
			return `${SUMMARY_PAGE_VIEWS_RESOURCE_KEY}_${projectKey}`;
		},
		getData: async ({ match, query }, { tenantContext: { activationId: workspaceId } }) => {
			const { projectKey } = getProjectKeyId(match, query);
			const response = await (fg('jsm_project_summary_avp_m0_reporting_dev_endpoint')
				? performGetRequest<ViewsResponse>(
						`/gateway/api/jsm/reporting-dev/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`,
					)
				: performGetRequest<ViewsResponse>(
						`/gateway/api/jsm/reporting/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`,
					));
			const dashboardId = fg('platform_avp_dashboard-resource_jsm-proj-sum')
				? (response.views.find(({ type }) => type === 'DEFAULT')?.dashboardId ?? null)
				: null;
			return response
				? {
						...response,
						dashboardId,
					}
				: response;
		},
		maxAge: 1000 * 60 * 5, // 5 minutes
	},
);
